import React from 'react';
import IconDetail from '../../../assets/images/icon-search-detail2.png';
import IconCloseDetail from '../../../assets/images/icon-search-detail-close.png';

const WeekDayBoxes = ({ weekDays, thisWeekRecordCounts, selectedDate, onDateClick }) => {
  // 선택된 날짜의 요일 인덱스 찾기 (0: 월, 1: 화, ..., 6: 일)
  const selectedIndex = selectedDate ? weekDays.findIndex(item => {
    const formattedDate = `${item.fullDate.getFullYear()}-${String(item.fullDate.getMonth() + 1).padStart(2, '0')}-${String(item.fullDate.getDate()).padStart(2, '0')}`;
    return selectedDate === formattedDate;
  }) : -1;

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg mb-8 flex justify-center max-w-[1044px] mx-auto">
      <div className="text-center mb-4 w-[896px]">
        <div className="grid grid-cols-7 text-center mb-4 bg-[#F3F7FF] rounded-[200px] font-[700] text-[24px] text-[#9BA5C2] py-[10px]">
          {['월', '화', '수', '목', '금', '토', '일'].map((day, idx) => (
            <div 
              key={day} 
              className={`font-bold relative ${selectedIndex === idx ? 'text-white' : ''}`}
            >
              {selectedIndex === idx ? (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-8 h-8 bg-[#355BDF] rounded-full absolute"></div>
                  <span className="relative z-10">{day}</span>
                </div>
              ) : day}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-7 gap-2">
          {weekDays.map((item, index) => {
            const formattedDate = `${item.fullDate.getFullYear()}-${String(item.fullDate.getMonth() + 1).padStart(2, '0')}-${String(item.fullDate.getDate()).padStart(2, '0')}`;
            const isSelected = selectedDate === formattedDate;
            const hasRecords = thisWeekRecordCounts[item.day] > 0;
            
            return (
              <div 
                key={item.day} 
                className={`rounded-lg flex flex-col justify-between w-[104px] h-[104px] mx-auto border-[1px] relative ${
                  isSelected
                    ? 'border-[#355BDF] border-[3px] shadow-md cursor-pointer'
                    : hasRecords
                      ? 'border-[#B5B7BD] bg-white cursor-pointer hover:shadow-md'
                      : 'border-[#B5B7BD] bg-[#F2F2F2]'
                }`}
                onClick={() => hasRecords && onDateClick(item)}
              >
                <div className={`text-[18px] font-[500] text-left ${
                  isSelected
                    ? 'pl-[10px] pt-[6px] text-[#355BDF]': 
                      'pl-[12px] pt-[8px] text-[#757575] '}`}>{item.date}일</div>
                
                {/* 상세 이미지 표시 */}
                {hasRecords && (
                  <div className={`absolute ${isSelected ? ' top-[-6px] right-[-6px]' : ' top-[-4px] right-[-4px]'}`}>
                    <img 
                      src={isSelected ? IconCloseDetail : IconDetail} 
                      alt={isSelected ? "닫기" : "상세보기"} 
                      className="w-8 h-8"
                    />
                  </div>
                )}
                
                <div 
                  className={`text-right text-[25px] font-[700] ${ isSelected ? ' pr-[6px] pb-[2px]  text-[#355BDF]':
                    hasRecords
                      ? ' pr-[8px] pb-[4px] text-[#757575]'
                      : ' pr-[8px] pb-[4px] text-[#DBDBDB]'
                  }`}
                >
                  {hasRecords 
                    ? `${thisWeekRecordCounts[item.day]}개` 
                    : '0개'}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WeekDayBoxes; 